import http from "@utils/request";
//获取实时数据
// sitelist: 站点编号列表,以逗号分隔
// orderName：排序名称按哪个字段进行排序
// direction: 排序方式(asc,desc)
export const realData = (sitelist, ordername="SiteNo", direction="asc") => http({
  method: "POST",
  url: "/phemsjava/getCurrentData",
  data: {
    sitelist, ordername, direction
  }
});


export const getInitialFlux = (type) => http({
  method: "POST",
  url: "/bigdata/getInitialFlux",
  data: {
    type
  }
});


